import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { Position } from "../../../api";
import { PagedApiState } from "../../../api/useApiState";
import { toAntdPagination } from "../../../util";
import { formatLocalizedDateTime } from "../../../util/formatting";

interface PositionTableProps {
  positions: PagedApiState<Position>;
  isLoading: boolean;
  visibleColumns: string[];
  style?: React.CSSProperties;
}

export function PositionTable({
  positions,
  isLoading,
  visibleColumns,
  style,
}: PositionTableProps) {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("timestamp"),
      key: "ts",
      render: (p: Position) => formatLocalizedDateTime(p.ts),
    },
    {
      title: t("latitude"),
      key: "lat",
      render: (p: Position) => p.lat?.toFixed(7),
    },
    {
      title: t("longitude"),
      key: "lon",
      render: (p: Position) => p.lon?.toFixed(7),
    },
    {
      title: "H. Acc.",
      key: "hAcc",
      render: (p: Position) => p.acc?.h?.toFixed(2),
    },
    {
      title: t("altitude"),
      key: "alt",
      render: (p: Position) => p.alt?.toFixed(2),
    },
    {
      title: t("sats-used"),
      key: "sats",
      render: (p: Position) => p.sats?.toFixed(0),
    },
    {
      title: "CPRS",
      key: "cprs",
      render: (p: Position) => p.cprs?.toFixed(0),
    },
  ];

  const filteredColumns = columns.filter((col) =>
    visibleColumns.includes(col.key as string)
  );
  return (
    <div
      className="custom-col-width-fit-table"
      data-testid="positions-table"
    >
      <Table
        sticky
        dataSource={positions?.value?.items || []}
        rowKey={(record) => JSON.stringify(record)}
        size="middle"
        loading={isLoading}
        columns={filteredColumns}
        pagination={toAntdPagination(positions, false)}
        style={style}
      />
    </div>
  );
}
